import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search-small",
  "use": "search-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"search-small\">\n  <path d=\"M12.844 13.34l-2.038-2.91c.849-.896 1.378-2.098 1.378-3.43 0-2.761-2.239-5-5-5s-5 2.239-5 5 2.238 5 5 5c.707 0 1.378-.151 1.989-.416l2.034 2.905c.591-.319 1.14-.705 1.637-1.149zM3.184 7c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4s-1.795 4-4 4c-2.206 0-4-1.794-4-4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol